import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import axios from 'axios';

import serverURI from 'config/URI';

import { toast } from 'react-toastify';

import { 
  Button, 
  Dialog, 
  ListItem, 
  Paper,
  ListItemText,
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  FormControlLabel,
  Radio,
  MenuItem,
  Card,
  CardHeader,
  // CardActions,
  CardContent,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';


//import { areas, groups, statusContracts, typesCompany } from 'common/datas';
import { IsNoU } from 'common/utils';


const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  registerListItemTitle: {
    //marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListTimeTitle: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
    width: '150px',
  },
  advertiseDefaultsTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
    //height: '42px',
  },
  registerListItemWideInput: {
    //marginLeft: theme.spacing(2),
    width: '480px',
    //height: '40px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  registerListItemDescriptionTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
    height: '40px',
  },
  registerListItemDescription: {
    //marginLeft: theme.spacing(2),
    width: '480px',
    height: '100px',
  },
  list_ads: {
    width: '100%',
    minWidth: 160,
    maxWidth: 160,
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    minHeight: 120,
    maxHeight: 120,
  },
  list_ads_section: {
    backgroundColor: 'inherit',
  },
  list_ads_ul: {
    backgroundColor: 'inherit',
    padding: 0,
  },
  list_ads_buttons: {
    maxWidth: 120,
    justifyContent: "center",
    padding: theme.spacing(2),
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const fetchJsFromCDN = (src, externals = []) => {
  new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.setAttribute('src', src)
    script.addEventListener('load', () => {
      resolve(externals.map(key => {
        const ext = window[key]
        typeof ext === 'undefined' && console.warn(`No external named '${key}' in window`)
        return ext
      }))
    })
    script.addEventListener('error', reject)
    document.body.appendChild(script)
  })
}

const RegisterManage = props => {

  const {
    className,
    type,
    openDialog,
    modeRegisterDialog,
    onClickCloseDialog,
    onClickSaveDialog,

    mod_user,
    editItem,
    areas,

    agencies,
    clients,
  } = props;

  const classes = useStyles();
  
  const [userID, setUserID] = useState('');
  const [disabledEditUserId, setDisabledEditUserId] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [telephone, setTelephone] = useState('');
  const [email, setEmail] = useState('');

  const [checkedActive, setCheckedActive] = useState(0);
  const handleChangeSwitchRadio = name => event => {
    //console.log('handleChangeSwitchRadio => '+event.target.checked);
    if (name==='checkedDeactive') {
      //setState({ ...state, ['checkedImage']: !event.target.checked });
      setCheckedActive(1);
    }
    else {
      setCheckedActive(0);
    }
  };

  const [checkedType, setCheckedType] = useState(0);
  const handleChangeSwitchGroup = name => event => {
    //console.log('handleChangeSwitchGroup => '+event.target.checked);
    if (name==='checkedAgency') {
      //setState({ ...state, ['checkedImage']: !event.target.checked });
      setCheckedType(1);
    }
    else if (name==='checkedClient') {
      //setState({ ...state, ['checkedImage']: !event.target.checked });
      setCheckedType(2);
    }
    else if (name==='checkedAdmin') {
      //setState({ ...state, ['checkedImage']: !event.target.checked });
      setCheckedType(3);
    }
    else {
      setCheckedType(0);
    }

    if (type === 'user') {
      if (!IsNoU(editItem))
      {
        // let selAgencies = editItem.agencies.map((user_agency, index) => {
        //   return agencies.find(agency => (agency.id === user_agency));
        // });
        // let selClients = editItem.clients.map((user_client, index) => {
        //   return clients.find(client => (client.id === user_client));
        // });
        setSelectedAgencies(editItem.agencies);
        setSelectedClients(editItem.clients);
      }
      else {
        setSelectedAgencies([]);
        setSelectedClients([]);
      }

      setSelectedIndexAgency(-1);
      setSelectedIndexClient(-1);
      setRemoveSelectedIndexAgency(-1);
      setRemoveSelectedIndexClient(-1);
    }
  };

  const getCheckedUserId = (userid) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/manage/user/checkuserid`,
      data: {
        userid: userid
      }
    });
  }

  // fetchPostInfo = async (postId) => {
  //   const post = await service.getPost(postId);
  //   console.log(post);
  //   const comments = await service.getComments(postId);
  //   console.log(comments);
  // }

  const handleClickCheckUserId = async () => {
    if (userID.length <= 0)
    {
      toast("아이디를 입력하세요.");
      return ;
    }
    const res = await getCheckedUserId(userID);
    //console.log(res);
    const checkeduserid = res.data.checkeduserid;
    //console.log(checkeduserid);
    setDisabledEditUserId(checkeduserid);
    if (checkeduserid) {
      toast("이용가능한 아이디입니다.");
    }
    else {
      toast(userID+" 아이디가 존재 합니다.");
    }
  }

  const getCheckedArea = (name) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/manage/area/check`,
      data: {
        name: name
      }
    });
  }

  const getCheckedGroup = (name) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/manage/group/check`,
      data: {
        name: name
      }
    });
  }

  const [areaName, setAreaName] = useState('');
  const [groupName, setGroupName] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const handleChangeArea = event => {
    setSelectedArea(event.target.value);
  };

  const [play_rule, setPlayRule] = useState(0);

  const [selectedAgencies, setSelectedAgencies] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);

  const handleClickAdd = () => {
    if (checkedType === 1) {
      if (selectedIndexAgency !== -1) {
          let selectedAgency = agencies[selectedIndexAgency];
          let findObj = selectedAgencies.find(obj => obj.id === selectedAgency.id);
          if (IsNoU(findObj))
            setSelectedAgencies([...selectedAgencies, selectedAgency]);
      }
    }
    else if (checkedType === 2) {
      if (selectedIndexClient !== -1) {
        let selectedClient = clients[selectedIndexClient];
        let findObj = selectedClients.find(obj => obj.id === selectedClient.id);
        if (IsNoU(findObj))
          setSelectedClients([...selectedClients, selectedClient]);
      }
    }
  }

  const handleClickRemove = () => {
    if (checkedType === 1) {
      if (removeSelectedIndexAgency !== -1 && selectedAgencies.length > 0) {
          let selectedAgency = selectedAgencies[removeSelectedIndexAgency];
          let newSelectedAgencies = selectedAgencies.filter(agency => agency.id !== selectedAgency.id);
          setSelectedAgencies(newSelectedAgencies);
          setRemoveSelectedIndexAgency(-1);
      }
    }
    else if (checkedType === 2) {
      if (selectedIndexClient !== -1 && selectedClients.length > 0) {
        let selectedClient = selectedClients[removeSelectedIndexClient];
          let newSelectedClients = selectedClients.filter(client => client.id !== selectedClient.id);
          setSelectedClients(newSelectedClients);
          setRemoveSelectedIndexClient(-1);
      }
    }
  }

  const [selectedIndexAgency, setSelectedIndexAgency] = useState(-1);

  const handleListItemClickAgency = (event, index) => {
    setSelectedIndexAgency(index);
  };

  const [selectedIndexClient, setSelectedIndexClient] = useState(-1);

  const handleListItemClickClient = (event, index) => {
    setSelectedIndexClient(index);
  };

  const [removeSelectedIndexAgency, setRemoveSelectedIndexAgency] = useState(-1);

  const handleListItemClickSelectedAgency = (event, index) => {
    setRemoveSelectedIndexAgency(index);
  };

  const [removeSelectedIndexClient, setRemoveSelectedIndexClient] = useState(-1);

  const handleListItemClickSelectedClient = (event, index) => {
    setRemoveSelectedIndexClient(index);
  };

  useEffect(() => {
    //console.log("componentDidMount");

//     const eruda = fetchJsFromCDN('https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js', ['eruda'])
// //      .then(([eruda]) => eruda.init())

    if (!IsNoU(editItem))
    {
      if (type === 'user') {
        setUserID(editItem.userid);
        setDisabledEditUserId(true);
        setUserName(editItem.name);
        setPassword('');
        setPasswordConfirm('');
        setTelephone('');
        setEmail(editItem.email);
        if (editItem.active === true)
          setCheckedActive(0);
        else
          setCheckedActive(1);

        if (editItem.role === 'user')
          setCheckedType(0);
        else if (editItem.role === 'agency')
          setCheckedType(1);
        else if (editItem.role === 'client')
          setCheckedType(2);
        else if (editItem.role === 'admin')
          setCheckedType(3);

        setSelectedAgencies(editItem.agencies);
        setSelectedClients(editItem.clients);

        setSelectedIndexAgency(-1);
        setSelectedIndexClient(-1);
        setRemoveSelectedIndexAgency(-1);
        setRemoveSelectedIndexClient(-1);
      }
      else if (type === 'area') {
        setAreaName(editItem.name);
      }
      else if (type === 'group') {
        setGroupName(editItem.name);
        setSelectedArea(areas.length > 0 ? areas[0].name : '');
      }
      else if (type === 'rule') {
        setPlayRule(editItem.play_rule);
      }
    }
    else {
        setUserID('');
        setDisabledEditUserId(false);
        setUserName('');
        setPassword('');
        setPasswordConfirm('');
        setTelephone('');
        setEmail('');
        setCheckedActive(0);
        setCheckedType(0);

        setSelectedAgencies([]);
        setSelectedClients([]);

        setSelectedIndexAgency(-1);
        setSelectedIndexClient(-1);
        setRemoveSelectedIndexAgency(-1);
        setRemoveSelectedIndexClient(-1);

        setAreaName('');

        setGroupName('');
        setSelectedArea(areas.length > 0 ? areas[0].name : '');

        setPlayRule(0);
    }

  }, [editItem]); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log("componentDidUpdate -> " + areas + areas.length);
    if (areas.length > 0) {
      setSelectedArea(areas[0].name);
    }
    else {
      setSelectedArea('');
    }
  }, [areas]);

  const rednerRegisterUser = (
    <List>
      <ListItem>
        <Card
          className={clsx(classes.card_root, className)}
        >
          <CardHeader
            className={classes.card_header}
            title={modeRegisterDialog ? '사용자 등록' : '사용자 수정'}
            subheader='*표시는 필수 항목'
          />
          <CardContent className={classes.content}>
            <List>
              <ListItem className={classes.listitem_align}>
                <TextField 
                  className={classes.registerListItemInput}
                  id="outlined-basic-reg-user-id"
                  label='아이디'
                  required
                  //variant="outlined" 
                  placeholder="영문만 입력 가능합니다."
                  disabled={disabledEditUserId}
                  value={userID}
                  onChange={e => { 
                    let value = e.target.value;
                    let prev = value;
        //            console.log(value);
                    value = value.replace(/[^A-Za-z0-9]/ig, '');
        //            console.log(value);
                    if (prev !== value) {
                      toast('영문,숫자만 입력 가능합니다.');
                    }
                    setUserID(value);
                  }}
                  margin="dense"/>

                <Box p={1} />

                <Button
                  color="primary"
                  variant="contained"
                  disabled={disabledEditUserId}
                  onClick={ () => { handleClickCheckUserId(); } }
                >
                  중복확인
                </Button>

              </ListItem>
              <Divider />
              <ListItem>
                <TextField 
                  className={classes.registerListItemInput}
                  id="outlined-basic-reg-user-name"
                  label='사용자명'
                  required
                  //variant="outlined" 
                  value={userName}
                  onChange={event=> setUserName(event.target.value)}
                  margin="dense"/>

              </ListItem>
              <Divider />
              <ListItem>
                <TextField 
                  className={classes.registerListItemInput}
                  id="outlined-basic-reg-user-password"
                  label='비밀번호'
                  required
                  //variant="outlined" 
                  value={password}
                  onChange={event=> setPassword(event.target.value)}
                  margin="dense"/>
              </ListItem>
              <Divider />
              <ListItem>
                <TextField 
                  className={classes.registerListItemInput}
                  id="outlined-basic-reg-user-pass-confirm"
                  label='비밀번호 확인'
                  required
                  //variant="outlined" 
                  value={passwordConfirm}
                  onChange={event=> setPasswordConfirm(event.target.value)}
                  margin="dense"/>
              </ListItem>
              <Divider />
              <ListItem>
                <TextField 
                  className={classes.registerListItemInput}
                  id="outlined-basic-reg-user-phone"
                  label='전화번호'
                  //variant="outlined" 
                  value={telephone}
                  onChange={event=> setTelephone(event.target.value)}
                  margin="dense"/>
              </ListItem>
              <Divider />
              <ListItem>
                <TextField 
                  className={classes.registerListItemInput}
                  id="outlined-basic-reg-user-email"
                  label='이메일'
                  //variant="outlined" 
                  value={email}
                  onChange={event=> setEmail(event.target.value)}
                  margin="dense"/>
              </ListItem>
              <Divider />
              <ListItem>
                <Typography
                  className={classes.registerListItemTitle}
                  color="textSecondary"
                  required
                  gutterBottom
                >
                  사용자 상태 *
                </Typography>
                <FormControlLabel
                  control={
                    <Radio
                      checked={checkedActive === 0}
                      onChange={handleChangeSwitchRadio('checkedActive')}
                      value="checkedActive"
                      color="primary"
                    />
                  }
                  label="Active"
                />

                <FormControlLabel
                  control={
                    <Radio
                      checked={checkedActive === 1}
                      onChange={handleChangeSwitchRadio('checkedDeactive')}
                      value="checkedActive"
                      color="primary"
                    />
                  }
                  label="InActive"
                />
              </ListItem>
              <Divider />
              <ListItem>
                <Typography
                  className={classes.registerListItemTitle}
                  color="textSecondary"
                  gutterBottom
                >
                  사용자 그룹 *
                </Typography>
                <FormControlLabel
                  control={
                    <Radio
                      checked={checkedType === 0}
                      onChange={handleChangeSwitchGroup('checkedUser')}
                      value="checkedType"
                      color="primary"
                    />
                  }
                  label="관계자"
                />

                <FormControlLabel
                  control={
                    <Radio
                      checked={checkedType === 1}
                      onChange={handleChangeSwitchGroup('checkedAgency')}
                      value="checkedType"
                      color="primary"
                    />
                  }
                  label="광고대행사"
                />

                <FormControlLabel
                  control={
                    <Radio
                      checked={checkedType === 2}
                      onChange={handleChangeSwitchGroup('checkedClient')}
                      value="checkedType"
                      color="primary"
                    />
                  }
                  label="광고주"
                />

                <FormControlLabel
                  control={
                    <Radio
                      checked={checkedType === 3}
                      onChange={handleChangeSwitchGroup('checkedAdmin')}
                      value="checkedType"
                      color="primary"
                    />
                  }
                  label="관리자"
                />
              </ListItem>
              {/* {console.log('check type -> ' + checkedType)}
              {console.log(agencies)}
              {console.log(clients)} */}
              {(checkedType === 1 || checkedType === 2) && 
              (
                <ListItem>
                  <Typography
                    className={classes.registerListItemTitle}
                    color="textSecondary"
                    required
                    gutterBottom
                  >
                  </Typography>
                  <Paper>
                    <List className={classes.list_ads}>
                      {(checkedType === 1) && agencies.map( (agency, index) => (
                        <ListItem 
                          button 
                          key={agency.id}
                          selected={selectedIndexAgency === index}
                          onClick={(e) => handleListItemClickAgency(e, index)}
                        >
                          <ListItemText primary={agency.name} />
                        </ListItem>
                      ))}
                      {(checkedType === 2) && clients.map( (client, index) => (
                        <ListItem 
                          button 
                          key={client.id}
                          selected={selectedIndexClient === index}
                          onClick={(e) => handleListItemClickClient(e, index)}
                        >
                          <ListItemText primary={client.name} />
                        </ListItem>
                      ))}
                    </List>
                  </Paper>
                  <div className={classes.list_ads_buttons}>
                    <Button variant="contained" onClick={e => handleClickAdd()}>{`추가>`}</Button>
                    <Box padding={1}/>
                    <Button variant="contained" onClick={e => handleClickRemove()}>{`<삭제`}</Button>
                  </div>
                  <Paper>
                    <List className={classes.list_ads}>
                    {(checkedType === 1) && selectedAgencies.map( (agency, index) => (
                        <ListItem 
                          button
                          key={agency.id}
                          selected={removeSelectedIndexAgency === index}
                          onClick={(e) => handleListItemClickSelectedAgency(e, index)}
                        >
                          <ListItemText primary={agency.name} />
                        </ListItem>
                      ))}
                      {(checkedType === 2) && selectedClients.map( (client, index) => (
                        <ListItem 
                          button 
                          key={client.id}
                          selected={removeSelectedIndexClient === index}
                          onClick={(e) => handleListItemClickSelectedClient(e, index)}
                        >
                          <ListItemText primary={client.name} />
                        </ListItem>
                      ))}
                    </List>
                  </Paper>
                </ListItem>
              )}
              <Divider />
            </List>
          </CardContent>
        </Card>
      </ListItem>
    </List>
  );

  const renderRegisterArea = (
    <List>
      <ListItem>
        <Card
          className={clsx(classes.card_root, className)}
        >
          <CardHeader
            className={classes.card_header}
            title={modeRegisterDialog ? '권역 등록' : '권역 수정'}
            subheader='*표시는 필수 항목'
          />
          <CardContent className={classes.content}>
            <List>
              <ListItem className={classes.listitem_align}>
                <TextField 
                  className={classes.registerListItemWideInput}
                  id="outlined-basic-reg-campaign-name"
                  label="권역명"
                  required
                  //variant="outlined" 
                  value={areaName}
                  onChange={event=> setAreaName(event.target.value)}
                  margin="dense"/>
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </ListItem>
      <Divider />
    </List>
  );

  const renderRegisterGroup = (
    <List>
      <ListItem>
        <Card
          className={clsx(classes.card_root, className)}
        >
          <CardHeader
            className={classes.card_header}
            title={modeRegisterDialog ? '그룹 등록' : '그룹 수정'}
            subheader='*표시는 필수 항목'
          />
          <CardContent className={classes.content}>
            <List>
              <ListItem className={classes.listitem_align}>
                <TextField 
                  className={classes.registerListItemWideInput}
                  id="outlined-basic-reg-campaign-name"
                  label='그룹명'
                  required
                  //variant="outlined" 
                  value={groupName}
                  onChange={event=> setGroupName(event.target.value)}
                  margin="dense"/>
              </ListItem>
              <Divider />
              <ListItem>
                <TextField
                  className={classes.registerListIteminput}
                  id="id-select-area"
                  label='권역'
                  select
                  required
                  value={selectedArea}
                  onChange={handleChangeArea}
                  //variant="outlined"
                  margin="dense"
                >
                  {areas.map(area => (
                    <MenuItem key={area.name} value={area.name}>
                      {area.name}
                    </MenuItem>
                  ))}
                </TextField>
              </ListItem>
              <Divider />
            </List>
          </CardContent>
        </Card>
      </ListItem>
    </List>
  );

  const renderRegisterRule = (
    <List>
      <ListItem>
        <Card
          className={clsx(classes.card_root, className)}
        >
          <CardHeader
            className={classes.card_header}
            title={'광고유효시간 수정'}
            subheader='*표시는 필수 항목'
          />
          <CardContent className={classes.content}>
            <List>
              <ListItem className={classes.listitem_align}>
                <TextField 
                  className={classes.registerListItemInput}
                  id="outlined-basic-reg-campaign-name"
                  label='광고유효시간'
                  required
                  //variant="outlined" 
                  value={play_rule}
                  onChange={event=> setPlayRule(event.target.value)}
                  margin="dense"/>
                  %
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </ListItem>
    </List>
  );

  return (
    <div>
      <Dialog fullScreen 
        open={openDialog} 
        onClose={() => {onClickCloseDialog(); setDisabledEditUserId(false);}} 
        TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" 
              onClick={() => {onClickCloseDialog(); setDisabledEditUserId(false);}} 
              aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              {type === 'user' ? '사용자' : type === 'area' ? '권역' : type === 'group' ? '그룹' : '광고유효시간'}  
            </Typography>
            <Button autoFocus color="inherit" onClick={ async () => {

                let newItem;
                if (type === 'user') {

                  if (IsNoU(userID) || userID.length <= 0) {
                    toast("아이디를 입력하세요.");
                    return ;
                  }

                  if (disabledEditUserId === false) {
                    toast("아이디 중복 확인을 하세요.");
                    return ;
                  }

                  if (IsNoU(userName) || userName.length <= 0) {
                    toast("사용자 이름을 입력하세요.");
                    return ;
                  }

                  if (IsNoU(password) || password.length <= 0) {
                    toast("비밀번호를 입력하세요.");
                    return ;
                  }
      
                  if (IsNoU(passwordConfirm) || passwordConfirm.length <= 0) {
                    toast("비밀번호 확인을 입력하세요.");
                    return ;
                  }

                  if (password !== passwordConfirm) {
                    toast("비밀번호를 다시 확인해주세요.");
                    return ;
                  }

                  newItem = {
                    userid: userID,
                    name: userName,
                    password: password,
                    email: email,
                    active: checkedActive===0,
                    agencies: selectedAgencies,
                    clients: selectedClients,
                    reg_at: new Date(),
                  };
                  newItem.role = (checkedType===3) ? 'admin' : 
                                 (checkedType===2) ? 'client' : 
                                 (checkedType===1) ? 'agency' :
                                 'user' ;
                }
                else if (type === 'area') {
                  if (IsNoU(areaName) || areaName.length <= 0) {
                    toast("권역명을 입력하세요.");
                    return ;
                  }
                  const res = await getCheckedArea(areaName);
                  //console.log(res);
                  const checked_area = res.data.checked_area;
                  if (!checked_area) {
                    toast(areaName+" 권역 명이 존재합니다..");
                    return ;
                  }

                  newItem = {
                    name: areaName,
                    reg_user: mod_user,
                    reg_at: new Date(),
                  };
                }
                else if (type === 'group') {
                  if (IsNoU(groupName) || groupName.length <= 0) {
                    toast("그룹명을 입력하세요.");
                    return ;
                  }

                  const res = await getCheckedGroup(groupName);
                  //console.log(res);
                  const checked_group = res.data.checked_group;
                  if (!checked_group) {
                    toast(groupName+" 그룹 명이 존재합니다..");
                    return ;
                  }

                  newItem = {
                    name: groupName,
                    area: selectedArea,
                    reg_user: mod_user,
                    reg_at: new Date(),
                  };
                }
                else if (type === 'rule') {
                  newItem = {
                    play_rule: play_rule,
                    modified_user: mod_user,
                    modified_at: new Date(),
                  };
                }

                if (!IsNoU(editItem))
                    newItem.id = editItem.id;

                onClickSaveDialog(newItem);
              }}>
              저장
            </Button>
          </Toolbar>
        </AppBar>

        {type === 'user' && rednerRegisterUser }
        {type === 'area' && renderRegisterArea }
        {type === 'group' && renderRegisterGroup }
        {type === 'rule' && renderRegisterRule }
      </Dialog>

    </div>
  );
}

RegisterManage.propTypes = {
  agencies: PropTypes.array.isRequired,
  clients: PropTypes.array.isRequired
};

RegisterManage.defaultProps = {
  areas: [],

  agencies: [],
  clients: [],
};

export default RegisterManage;